import {printoutPalette} from "../../core/printoutPalette";
import {printoutTheme, printoutTypeSx} from "../../core/printoutTheme";

export const dividerBlockSx = {
    "& .printout-divider-block-line, & .printout-rendered-divider-line": {
        backgroundColor: printoutPalette.border,
        border: 0,
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        width: "100%",
        // Keep each rule intact when native print pagination takes over.
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    "& .printout-rendered-divider-block": {
        margin: "16px 0",
    },
    // A labelled divider is one unbreakable rule-caption-rule row.
    "& .printout-divider-block-labeled, & .printout-rendered-divider-block-labeled": {
        alignItems: "center",
        display: "flex",
        gap: "12px",
        width: "100%",
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    [[
        "& .printout-divider-block-labeled .printout-divider-block-line",
        "& .printout-rendered-divider-block-labeled .printout-rendered-divider-line",
    ].join(", ")]: {
        flex: "1 1 auto",
        minWidth: "8px",
        width: "auto",
    },
    "& .printout-divider-block-label, & .printout-rendered-divider-label": {
        color: printoutPalette.mutedText,
        flex: "0 0 auto",
        ...printoutTypeSx(printoutTheme.type.label),
        whiteSpace: "nowrap",
    },
};
